<div class="footer shadow-4 flex justify-content-center">
  <div class="flex height-100 width-100 justify-content-between" style="max-width: 900px">
    <div class="ml-2">
      <a pButton pRipple class="hoverable p-button-text p-button-plain rounded-circle p-button-icon-only" type="button"
        icon="pi pi-home fs-large" [routerLinkActive]="['p-highlight']" [routerLinkActiveOptions]="{ exact: true }"
        [routerLink]="['/']" (click)="handleFooterActionClick()"
        data-tutorial="tutorial-footer-home">
      </a>
    </div>
    <ng-container *ngFor="let item of navigationItemsBeforeAdd">
      <div>
        <ng-container *ngIf="isCustomFooterIcon(item); else footerPrimeIconBeforeAdd">
          <a
            pButton
            pRipple
            class="hoverable p-button-text p-button-plain rounded-circle p-button-icon-only footer-nav-button--custom-icon"
            type="button"
            [class.p-highlight]="isNavigationItemActive(item)"
            [routerLink]="item.routerLink"
            [attr.aria-label]="item.labelKey | translate"
            [attr.title]="item.labelKey | translate"
            [attr.data-tutorial]="item.footerTutorialKey || null"
            (click)="handleFooterActionClick()"
          >
            <span class="footer-nav-custom-icon-wrapper" aria-hidden="true">
              <span class="footer-nav-custom-icon navigation-vehicles-icon"></span>
            </span>
          </a>
        </ng-container>
        <ng-template #footerPrimeIconBeforeAdd>
          <a
            pButton
            pRipple
            class="hoverable p-button-text p-button-plain rounded-circle p-button-icon-only"
            type="button"
            [icon]="item.icon"
            [class.p-highlight]="isNavigationItemActive(item)"
            [routerLink]="item.routerLink"
            [attr.aria-label]="item.labelKey | translate"
            [attr.title]="item.labelKey | translate"
            [attr.data-tutorial]="item.footerTutorialKey || null"
            (click)="handleFooterActionClick()"
          >
          </a>
        </ng-template>
      </div>
    </ng-container>
    <ng-container *ngIf="useContextualAction && mobileAction; else legacyAddAction">
      <button type="button" [icon]="mobileAction.icon" pButton
              class="hoverable rounded-circle p-button-icon-only footer-add-button"
              (click)="runMobileAction()"
              [attr.aria-label]="mobileAction.labelKey | translate"
              [attr.title]="mobileAction.labelKey | translate"
              data-tutorial="tutorial-footer-add"></button>
    </ng-container>
    <ng-template #legacyAddAction>
    <ng-container *ngIf="actionsService.hasAddAction">
      <div
        *ngxPermissionsOnly="actionsService.contextUser ? [actionsService.contextUser | ownerRole] : actionsService.permissions">
        <button type="button" icon="pi pi-plus fs-large" pButton
                class="hoverable rounded-circle p-button-icon-only footer-add-button"
                [disabled]="actionsService.addDisabled"
                (click)="handleFooterActionClick(); actionsService.onAdd({isOpened: true})"
                data-tutorial="tutorial-footer-add"></button>
      </div>
    </ng-container>
    </ng-template>
    <ng-container *ngFor="let item of navigationItemsAfterAdd">
      <div>
        <ng-container *ngIf="isCustomFooterIcon(item); else footerPrimeIconAfterAdd">
          <a
            pButton
            pRipple
            class="hoverable p-button-text p-button-plain rounded-circle p-button-icon-only footer-nav-button--custom-icon"
            type="button"
            [class.p-highlight]="isNavigationItemActive(item)"
            [routerLink]="item.routerLink"
            [attr.aria-label]="item.labelKey | translate"
            [attr.title]="item.labelKey | translate"
            [attr.data-tutorial]="item.footerTutorialKey || null"
            (click)="handleFooterActionClick()"
          >
            <span class="footer-nav-custom-icon-wrapper" aria-hidden="true">
              <span class="footer-nav-custom-icon navigation-vehicles-icon"></span>
            </span>
          </a>
        </ng-container>
        <ng-template #footerPrimeIconAfterAdd>
          <a
            pButton
            pRipple
            class="hoverable p-button-text p-button-plain rounded-circle p-button-icon-only"
            type="button"
            [icon]="item.icon"
            [class.p-highlight]="isNavigationItemActive(item)"
            [routerLink]="item.routerLink"
            [attr.aria-label]="item.labelKey | translate"
            [attr.title]="item.labelKey | translate"
            [attr.data-tutorial]="item.footerTutorialKey || null"
            (click)="handleFooterActionClick()"
          >
          </a>
        </ng-template>
      </div>
    </ng-container>
    <div>
      <a pButton pRipple class="hoverable p-button-text p-button-plain rounded-circle p-button-icon-only" type="button"
         icon="pi pi-search fs-large" (click)="handleSearchButtonClick($event)"
         data-tutorial="tutorial-footer-search">
      </a>
    </div>
    <div>
      <a pButton pRipple class="hoverable p-button-text p-button-plain rounded-circle p-button-icon-only" type="button"
         [routerLinkActive]="['p-highlight']" [routerLink]="['/chat']"
         (click)="handleFooterActionClick()"
         data-tutorial="tutorial-footer-chat">
        <span class="p-overlay-badge">
          <i *ngIf="!unreadChatCount" class="pi pi-comments fs-large"></i>
          <i *ngIf="unreadChatCount" class="pi pi-comments fs-large" pBadge
             [value]="unreadChatCount" badgeSize="large"></i>
        </span>
      </a>
    </div>
    <div class="mr-2">
      <a (click)="navigateToProfileOrGarage($event)" (tap)="navigateToProfileOrGarage($event)" pButton pRipple
         type="button" [class.p-highlight]="isActive"
         class="hoverable p-button-text p-button-plain mr-1 rounded-circle p-button-icon-only footer-profile-button"
         data-tutorial="tutorial-footer-profile">
        <app-thumbnail [imgSrc]="this.user.avatar | mediaObject" [circle]="true" [bordered]="true"
                       stylesList="width: 28px; height: 28px;"></app-thumbnail>
      </a>
    </div>
  </div>

</div>
